export default {
  getReportAdjustments: (state) => state.reportAdjustments,
};
